<script>
import EntitiesTable from '$common/EntitiesTable'
export default {
  name: 'AdminDiscountCodes',
  components: {
    'entities-table': EntitiesTable,
  },
  data () {
    return {
      discountCodes: [],
      cells: [
        {
          name: 'Code',
          getInfo: code => code.code,
          sortFunc: (a, b) => a.code.localeCompare(b.code),
          onClick: (code) => {
            this.$modals.show({
              name: 'redemption-list',
              type: 'discount_codes',
              id: code.id,
            })
          },
        },
        {
          name: 'Amount',
          getInfo: code => `$${code.amount}`,
          sortFunc: (a, b) => Number(a.amount) < Number(b.amount) ? 1 : -1
        },
        {
          name: 'Status',
          getInfo: code => code.status.toLowerCase(),
          sortFunc: (a, b) => a.status.localeCompare(b.status)
        },
        {
          name: 'Edit',
          getInfo: () => 'Edit',
          classFunc: () => 'action-link',
          onClick: (code) => {
            this.$modals.show({
              name: 'create-discount-code',
              onSuccess: this.getDiscountCodes,
              info: code,
            })
          }
        },
      ],
      sorting: {
        ascending: true,
        by: 'Code',
      },
      isReady: false,
    }
  },
  computed: {
    filteredCodes () {
      const sortFunc = this.cells.find(cell => cell.name === this.sorting.by).sortFunc
      const sorted = this.$clone(this.discountCodes).sort(sortFunc)
      return this.sorting.ascending ? sorted : sorted.reverse()
    },
  },
  methods: {
    async getDiscountCodes () {
      return new Promise(async (resolve, reject) => {
        const codes = (await this.$firestore.collection('discount_codes').get()).docs.map(doc => doc.data())
        return resolve(codes)
      })
    },
  },
  async mounted () {
    this.discountCodes = await this.getDiscountCodes()
    this.isReady = true
  },
}
</script>

<template lang="pug">
  #admin-guardians-main.admin-main
    .admin-guardians-container.admin-container
      .admin-title Discount Codes
        .button.pro-button.minor(@click='$modals.show({name: "create-discount-code", onSuccess: getDiscountCodes,})') Create Discount Code
      .admin-content
        entities-table(
          :entities='filteredCodes'
          :cells='cells'
          :initialSorting='sorting'
          :isReady='isReady'
          customColumnWidths='200px 200px 200px 75px'
          @onSortingChange='newSorting => sorting = newSorting'
          :tableStyle='{"max-width": "calc(100vw - 400px)"}'
        )
</template>

<style lang="sass" scoped>
  #admin-invoices-main
    .admin-invoices-container
</style>